<template>
  <div>
  <div><strong>{{ item.formattedGuest_id || item.patient_RegId }}</strong></div>
  <div>
    {{ item.firstname || item.name}} {{ item.middlename }} {{ item.lastname }}
  </div>
  <div>{{ item.mobile }}</div>
</div>
</template>
 
<script>
export default {
  props: {
    item: { required: true },
    searchText: { required: true }
  }
}
</script> 